<template>
  <div class="page" style="position: relative;">
    <zdyloading v-if="countCur == 1 && scenarioName != '智能客服'" style="position: absolute;top: 0;left: 0;"
                ref="zdyloading" :isShowLoading="loading" loadingTxt="加载中..."
                :backgroundStyle="'linear-gradient(135deg, #1a1a2e, #16213e)'" :textStyle="'#fff'">
    </zdyloading>
    <caseheader></caseheader>
    <div class="content-btns">
      <div class="btns">
        <div class="l-btn-1" @click="onCreateWorkflow" v-show="isCJTY == 0">搭建业务工作流</div>
        <div class="l-btn-2" @click="onClickSetting">其他配置</div>
        <div class="l-btn-3" @click="onBackDYGPT" v-show="isCJTY == 0">返回DYGPT</div>
      </div>
    </div>
    <div class="content-wrap" :class="isCJTY == 0 ? 'content-wrap-zc' : 'content-wrap-cjty'">
      <div class="box">
        <div class="box-inner">
          <span>{{ param.type }}</span>
        </div>
        <ul ref="dialogBox" :class="{ 'isSample': sampleShow }">
          <li v-for="(item, index) in msgList" :key="index" :class="{ 'isMy': item.isMy, 'isSample': item.type == 2 }">
            <div class="msg-inner">
              <div class="pic">
                <img v-if="item.isMy" src="./imgs/Group_242@2x.png">
                <img v-else src="./imgs/ac4856.png">
              </div>
              <div class="text" v-show="!item.loading">
                <p>{{ item.isMy ? '用户' : param.name }}</p>
                <span class="msg">{{ item.text }}</span>
              </div>
              <div class="text" v-show="item.loading">
                <span class="el-icon-loading"></span>
              </div>
            </div>
          </li>
        </ul>

        <!-- 语音浮动版 -->
        <div class="sample-view" v-show="sampleShow">
          <img src="./imgs/sample.gif">
          <el-button class="sendBtn" size="mini" @click="handleSampleSend">发送</el-button>
          <el-button class="closeBtn" size="mini" @click="handleSampleClose">取消</el-button>
        </div>

        <!-- 发送框 -->
        <div class="sendBox" :class="{ 'disabled': loading }">
          <el-input ref="input" v-model="msgVal" :disabled="loading"
                    @keyup.enter.native="handleSend(msgVal)"></el-input>
          <div class="btn-inner">
            <microphone v-if="YYType === 1" class="huatong" ref="microphone" @start="onMicrophoneStart"
                        @end="onMicrophoneEnd"></microphone>
            <XFDictation v-else-if="YYType === 2" class="huatong" ref="microphone" @start="onMicrophoneStart"
                         @end="onMicrophoneEnd"></XFDictation>
          </div>
          <div class="btn-inner">
            <div class="sendBtn" @click="handleSend(msgVal)"><img src="./imgs/fasong-2_1@2x.png"></div>
          </div>
        </div>
      </div>

      <!-- 数字人 -->
      <div class="szr-wrap">
        <speaker ref="speaker" @load="speakerLoad" @loaded="onFigureLoad" style="width: 100%; height: 100%;"></speaker>
      </div>

      <!-- 得分板 -->
      <div class="scorePanel" v-show="scorePanel.show">
        <div class="title-inner">你的得分<span>总分：{{ scorePanel.score || 0 }}</span></div>
        <div class="content-inner">
          <el-table :data="scorePanel.tableData" v-loading="scorePanel.loading"
                    element-loading-background="rgba(29, 64, 94, 0.1)" height="100%" style="width: 100%">
            <el-table-column prop="text" label="任务"></el-table-column>
            <el-table-column prop="score" label="AI评分" width="75" align="center">
              <template slot-scope="scope">
                <span style="color: #0bc1f3;">{{ scope.row.score }}</span>
              </template>
            </el-table-column>
            <el-table-column label="解析" width="75" align="center">
              <template slot-scope="scope">
                <span v-show="scope.row.isLoad" style="color: #0bc1f3; cursor: pointer;"
                      @click="scorePanel.analysis = scope.row.analysis">查看</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="footer-innerr">
          <p v-html="scorePanel.analysis"></p>
        </div>
      </div>
    </div>

    <!--引导弹窗-->
    <guideDialog ref="guideDialog" @close="guideDialogClose"></guideDialog>

    <!--工作流配置 弹窗-->
    <workflowDialog ref="workflowDialog" :scenarioName="scenarioName" @cleanznkfMsglist="cleanznkfMsglist"
                    @getzntwenti="getzntwenti"></workflowDialog>

    <!-- 弹框： -->
    <creatDialog ref="creatDialog" @change="onFigureChange"></creatDialog>

  </div>
</template>

<script>
// import apiUser from "@/api/user";
import axios from 'axios'
// import speaker from './components/speaker/speaker.vue'
import speaker from './components/underspeaker/index.vue' // 假的
import microphone from './components/microphone/microphone'
import XFDictation from './components/XFDictation/index.vue'
import creatDialog from './creatDialog.vue'
import workflowDialog from './workflowDialog.vue'
import guideDialog from './guideDialog.vue'
import zdyloading from '@/components/Zdyloading.vue'
import Caseheader from '@/components/layout/caseheader.vue';

axios.defaults.timeout = 300000
axios.defaults.withCredentials = false
axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
// axios.defaults.headers['Authorization'] = `Bearer dygpt-xVvOqc2X5bjYEbFKSEE5i97v0flsDea5opUDvSR6bnr86N6GRuUOFVqjNmcEB`

export default {
  components: {
    speaker,
    microphone,
    XFDictation,
    creatDialog,
    workflowDialog,
    guideDialog,
    zdyloading,
    Caseheader
  },
  data () {
    return {
      casename: '',
      hasyindao: false,//是否有引导弹窗
      describtion: '',
      dialogVisible: false,
      //案例场景名称： 智能客服、智能体
      scenarioName: '',
      //案例类型：1.AI场景 2.工作流（用于控制案例描述流程图片显示）
      casetype: 1,
      // 使用语音服务：1=阿里云、2=讯飞
      YYType: window.YYType || 1,
      // API地址
      apiUrl: 'https://api.coze.cn/v1/workflow/run',
      apiUrl2: window.FastGptApiUrl + '/api/v1/chat/completions',
      // URL带参
      param: {},
      workflow_id: window.xlznt_flowId || '7486326208637567011',
      app_id: "7486012317290102784",
      // 得分相关
      scorePanel: {
        show: true,
        loading: false,
        score: 0,
        analysis: '',
        tableData: []
      },
      msgVal: '', // 问题发送文字
      msgList: [], // 对话列表
      loading: false,
      sampleShow: false, // 语音浮动板块显隐
      issuesData: {}, // 问题集（仅训练智能体使用）
      // 问题计数（仅训练智能体使用）
      countCur: 1,
      isCJTY: 0,//是否为场景体验进入
    }
  },
  computed: {

  },
  watch: {
    msgList (newVal, oldVal) {
      let dom = this.$refs['dialogBox']
      if (dom && newVal.length) {
        setTimeout(() => {
          dom.scrollTop = 9999999
        }, 100)
      }
    }
  },
  created () {
    this.$storeCase.init()

    this.isCJTY = sessionStorage.getItem('isCJTY') || 0
    this.scenarioName = sessionStorage.getItem('scenarioName')
    this.casename = sessionStorage.getItem('casename')
    this.describtion = sessionStorage.getItem('describtion')
    //得分板 : 如果是智能客服金融的，不显示得分板
    this.scorePanel.show = this.scenarioName == '智能客服' ? false : true

    //判断有无提问模块和计分模块的key值，有则直接运行获取问题
    if (this.scenarioName !== '智能客服') {
      let xlznt_tw_key = sessionStorage.getItem('xlznt_tw_key')
      let xlznt_jf_key = sessionStorage.getItem('xlznt_jf_key')
      if (!xlznt_tw_key || !xlznt_jf_key) {
        this.$alert('请完善搭建业务工作流信息中的API秘钥信息')
      }
      if (this.scenarioName == '训练智能体' && this.isCJTY == 1) {
        //获取得分
        this.getZntScore()
        //获取问题
        this.getZntAnswer()
      }
    }
  },
  mounted () {
    console.log("this.$router.query>>>", this.$route.query.caseno);
    //如果是非场景体验进入
    if (this.isCJTY == 0) {
      //默认进入会加载一个引导内容弹窗
      this.LoadguideDialog()
    }
  },
  destroyed () {
    sessionStorage.setItem('isCJTY', '')
  },
  methods: {
    // 加载引导页弹窗
    LoadguideDialog () {
      this.$refs['guideDialog'].show()
    },

    guideDialogClose () {
      if (this.scenarioName !== '智能客服') {
        //如果是训练智能体 通过dygpt返回时 清除缓存
        if (this.$route.query.caseno) {
          sessionStorage.setItem('xlznt_tw_key', '')
          sessionStorage.setItem('xlznt_jf_key', '')
        } else {
          this.getZntAnswer()
        }

      }
    },

    // 搭建业务工作流 点击
    onCreateWorkflow () {
      this.$refs['workflowDialog'].show()
    },

    //返回DYGPT
    onBackDYGPT () {
      // this.$router.push('/case/dygpt')
      let suiji = Math.random().toString(36).substring(2, 15)
      this.$router.push({ path: '/case/dygpt', query: { type: sessionStorage.getItem('casetype'), caseno: sessionStorage.getItem('caseno'), routename: 'zhinengkefu', extend: '', v: suiji } })
    },

    onClickSetting () {
      this.$refs.creatDialog.show()
    },

    // 切换数字人形象
    onFigureChange () {
      this.$refs.speaker.init()
      this.zloading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
    },

    onFigureLoad () {
      this.zloading?.close()
    },

    // 数字人加载完毕
    speakerLoad () {
      this.loading = false
      // if (this.param.isKefu) {
      if (this.scenarioName == '智能客服') {
        // let str = `您好，关于${this.param.keywords}相关的任何问题，您都可以向我咨询`
        let str = `您好，关于金融相关的任何问题，您都可以向我咨询`
        // this.msgList.push({
        //   isMy: false,
        //   text: str,
        // })
        // this.$refs['speaker'].playWelcome(str)
      }
    },

    // 获取AI问答（用于智能客服）
    getZnkfAnswer () {
      let znkf_key = sessionStorage.getItem('znkf_key')
      if (!znkf_key) {
        this.$message.warning('请先完成API秘钥配置！')
        return
      } else {
        this.loading = true
        this.msgList.push({
          isMy: false,
          text: '...',
          loading: true
        })
        axios({
          headers: {
            'Authorization': `Bearer ${znkf_key}`
          },
          url: this.apiUrl2,
          method: 'POST',
          data: {
            "stream": false,
            "detail": false,
            "chatId": sessionStorage.getItem('dygptaccount'),
            messages: [
              {
                "content": this.msgVal,
                "role": "user"
              }
            ]
          }
        }).then(res => {
          this.loading = false
          if (res?.data && (res.status == 200 || res.status == 304)) {
            let data = res.data
            if (data.code == 514 || data.code == 403) {
              this.$alert('AI客服模块工作流API秘钥不正确，请检查！')
              return
            } else {
              let text = data.choices[0].message.content || ''
              if(text.indexOf('</think>') > -1){
                text = text.split('</think>')[1]
              }
              this.msgList[this.msgList.length - 1] = {
                ...this.msgList[this.msgList.length - 1],
                ...data,
                text: text,
                loading: false
              }
              // 调用数字人说话
              this.$refs['speaker'].playWelcome(text)
            }
          }
        }).catch((err) => {
          console.log("Err>>>", err);
          this.$alert('当前网络连接错误，请检查后再试')
          this.loading = false
        })
      }
    },

    // 清除智能客服消息列表数据
    cleanznkfMsglist () {
      //清空所有问答列表
      this.msgList = []
    },

    // 业务工作流key配置好后，点击应用 直接拉取问题
    getzntwenti () {
      this.countCur = 1
      //先清空所有问答列表与 得分列表
      this.msgList = []
      let scorePanel = {
        show: true,
        loading: false,
        score: 0,
        analysis: '',
        tableData: []
      }
      this.scorePanel = scorePanel
      this.getZntAnswer()
    },

    // 获取智能体问题（用于训练智能体）
    async getZntAnswer () {
      let xlznt_tw_key = sessionStorage.getItem('xlznt_tw_key')
      this.loading = true
      this.msgList.push({
        isMy: false,
        text: '',
        loading: true
      })
      if (this.countCur === 1) {
        try {
          let res = await axios({
            headers: {
              'Authorization': `Bearer ${xlznt_tw_key}`
            },
            url: this.apiUrl2,
            method: 'POST',
            data: {
              "stream": false,
              "detail": false,
              "chatId": sessionStorage.getItem('dygptaccount'),
              // "chatId": '213',
              "variables": {},
              "messages": [
                {
                  "content": '1',
                  "role": "user"
                }
              ]
            }
          })
          console.log("训练智能体的返回data>>>", res);

          if (res?.data && (res.status == 200 || res.status == 304)) {
            let data = res.data
            //514 为秘钥不正确
            if (data.code == 514 || data.code == 403) {
              this.loading = false
              this.$alert('AI提问模块工作流API秘钥不正确，请检查！')
              return
            } else {
              let text = data.choices[0].message.content || ''
              // console.log(text);
              let firstIndex = text.indexOf("```json");
              let lastIndex = text.lastIndexOf("```");
              let substrValue = text.substr(firstIndex + 7, lastIndex);
              this.issuesData = JSON.parse(substrValue.replace(/\n/g, '').replace('```', ''))
              this.loading = false
              console.log("问题集：", this.issuesData)
            }
          }
        } catch (error) {
          console.log("error>>", error);
          this.$alert('当前网络连接错误，请检查后再试')
          this.loading = false
        }
      } else {
        await new Promise((resolve, reject) => {
          setTimeout(resolve, 2000);
          console.log(`ddddd2`)
        })
      }
      // let text = '111'
      let text = this.issuesData[`q${this.countCur}`]
      this.msgList[this.msgList.length - 1] = {
        ...this.msgList[this.msgList.length - 1],
        q1: text,
        text: text || '您已答完所有问题',
        loading: false
      }
      this.countCur++
      this.loading = false
      setTimeout(this.$refs['input']?.focus, 100)
      // 调用数字人说话
      this.$refs['speaker'].playWelcome(text)
    },

    //回答问题&获取分数和解析（训练智能体）
    getZntScore () {
      let xlznt_jf_key = sessionStorage.getItem('xlznt_jf_key')
      let arr = this.msgList
      console.log("回答问题&获取分数和解析-->>>", arr);
      if (arr.length && arr.length >= 1) {
        this.scorePanel.loading = true
        let row1 = arr[arr.length - 1].text // 回答
        let row2 = arr[arr.length - 2].q1 // 问题
        let id = this.getRandomString(15)
        this.scorePanel.tableData.push({
          id,
          // text: row2.text,
          text: row2,
          score: '',
          analysis: ''
        })
        console.log("回答》》》", row1);
        console.log("问题》》》", row2);

        axios({
          headers: {
            'Authorization': `Bearer ${xlznt_jf_key}`
          },
          url: this.apiUrl2,
          method: 'POST',
          data: {
            "stream": false,
            "detail": false,
            "chatId": sessionStorage.getItem('dygptaccount'),
            "variables": {
              "q": row2,
              "a": row1
            },
            messages: [
              {
                "content": this.msgVal,
                "role": "user"
              }
            ]
          }
        }).then(res => {
          this.scorePanel.loading = false
          if (res?.data && (res.status == 200 || res.status == 304)) {
            console.log("ai计分的结果为》》》", res);
            let data = res.data
            if (data.code == 514) {
              this.$alert('AI计分模块工作流API秘钥不正确，请检查！')
              return
            } else {
              let arr = data.choices[0].message.content || ''
              if (arr) {
                let newarr = arr.split('[解析：')
                console.log("newarr>>>>", newarr);

                let n = 0
                let regex = new RegExp(`\\[得分：(.*)\\]`)
                let s = Number(newarr[0].match(regex)?.[1] || '') || 0

                console.log("得分：", s);
                console.log("解析：", newarr[1]);

                this.scorePanel.tableData.forEach(item => {
                  if (item.id == id) {
                    item.score = s
                    item.analysis = newarr[1].replace(']', '') || ''
                    item.isLoad = true
                  }
                  n += (item.score || 0)
                })
                this.scorePanel.score = n
              }
            }

          }
        }).catch((err) => {
          console.log("Err>>>", err);
          this.$alert('当前网络连接错误，请检查后再试')
          this.loading = false
        })
      }
    },

    // 发送, str：问题, type：1文字，2语音文字
    handleSend (str, type) {
      console.log("this.param>>>", this.param);

      if (str && !this.loading) {
        // 插入我的回答
        this.msgList.push({
          isMy: true,
          text: str,
          type: type || 1
        })
        this.msgVal = str
        if (this.scenarioName == '智能客服') {
          console.log('进入了智能客服！！！');
          this.getZnkfAnswer()
        } else if (this.scenarioName == '训练智能体') {
          //获取得分
          this.getZntScore()
          //获取问题
          this.getZntAnswer()
        }
        this.msgVal = ''
      }
    },

    // 语音：监听开始
    onMicrophoneStart () {
      clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.sampleShow = true
      }, 100)
    },

    // 语音：监听完毕
    onMicrophoneEnd () {
      this.sampleShow = false
    },

    // 语音：确定发送
    handleSampleSend () {
      clearTimeout(this.timer1)
      this.timer1 = setTimeout(() => {
        this.$refs['microphone'].send && this.$refs['microphone'].send((data) => {
          if (data) {
            for (var i = 0; i < data.length; i++) {
              if (!data[i]) {
                data.splice(i, 1)
                i++
              }
            }
            let str = data.join('')
            this.handleSend(str, 2)
          }
        })
      }, 500)
    },

    // 语音：取消发送
    handleSampleClose () {
      this.$refs['microphone'].stop && this.$refs['microphone'].stop()
    },
  }
}
</script>

<style lang="less" scoped>
.page {
  .content-top {
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #f3faff;
    padding: 0 40px;

    .top-left {
      font-size: 16px;
    }

    .top-right {
      display: flex;

      .r-btn-miaoshu {
        width: 139px;
        height: 40px;
        line-height: 40px;
        background: #fff;
        border-radius: 9px;
        color: #666666;
        font-weight: bold;
        text-align: center;
        cursor: pointer;
        margin-right: 20px;

        &:hover {
          filter: hue-rotate(20deg) brightness(100%);
        }
      }

      .r-btn-jiaojuan {
        width: 139px;
        height: 40px;
        line-height: 40px;
        background: linear-gradient(90deg, #76E8FE 0%, #2187EC 100%);
        border-radius: 9px;
        color: #fff;
        font-weight: bold;
        text-align: center;
        cursor: pointer;

        &:hover {
          filter: hue-rotate(20deg) brightness(100%);
        }
      }
    }
  }

  .content-btns {
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 0 50px;

    .btns {
      display: flex;
      align-items: center;

      .l-btn-1,
      .l-btn-2,
      .l-btn-3 {
        width: 139px;
        height: 40px;
        line-height: 40px;
        background: linear-gradient(to bottom, #8bb0ff, #526ba2);
        border-radius: 9px;
        color: #fff;
        font-weight: bold;
        text-align: center;
        cursor: pointer;
        margin-right: 20px;
        box-shadow: 8px 6px 7px -2px rgba(255, 255, 255, 0.4);
        text-shadow: 1px 1px rgba(0, 0, 0, 0.3);

        &:hover {
          filter: hue-rotate(50deg) brightness(100%);
        }
      }

      .l-btn-1 {}

      .l-btn-2 {}

      .l-btn-3 {}
    }
  }

  .content-wrap-cjty {
    height: calc(100% - 60px);
  }

  .content-wrap-zc {
    height: calc(100% - 120px);
  }

  .content-wrap {
    padding: 10px 50px 40px 50px;
    box-sizing: border-box;
    // height: 100%;
    // height: calc(100% - 120px);
    display: flex;

    .box {
      backdrop-filter: blur(5px);
      background-color: rgba(51, 106, 135, 0.5);
      height: 100%;
      width: 100%;
      margin: 0 auto;
      border-radius: 10px;
      box-shadow: 0 0 20px -5px rgba(138, 220, 255, 0.6) inset;
      padding: 10px 18px;
      box-sizing: border-box;
      margin-right: 15px;
      border: 1px solid rgba(76, 151, 192, 0.6);

      .box-inner {
        height: 45px;
        font-size: 24px;
        border-bottom: 1px solid rgba(76, 151, 192, 0.6);
        box-sizing: border-box;
        display: flex;
        align-items: center;
        font-family: YouSheBiaoTiHei, YouSheBiaoTiHei;
        color: #3df2ff;

        span {
          margin-right: auto;
          line-height: 20px;
          text-shadow: 0 0 2px #d8f8ff;
        }
      }

      ul {
        height: calc(100% - 140px);
        margin: 15px 0;
        overflow: auto;
        padding: 0;
        padding-right: 10px;
        box-sizing: border-box;

        &.isSample {
          height: calc(100% - 160px);
        }

        li {
          margin-top: 10px;
          margin-bottom: 30px;
          font-size: 16px;
          min-height: 50px;

          &.isSample .text p::before {
            font-family: element-icons !important;
            content: "\e727";
            margin-right: 2px;
            color: #66b2d5;
          }

          .msg-inner {
            display: inline-block;
            padding-left: 60px;
            position: relative;
            max-width: 60%;
            min-width: 300px;

            .pic {
              width: 50px;
              height: 50px;
              position: absolute;
              left: 0;

              img {
                width: 100%;
                height: 100%;
              }
            }

            .text {
              position: relative;
              font-size: 16px;
              word-wrap: break-word;
              color: #fff;

              p {
                color: #009bde;
                margin-bottom: 5px;
                margin-top: 5px;
                user-select: none;
              }

              span {
                line-height: 1.4;
              }

              .el-icon-loading {
                margin-top: 12px;
                font-size: 20px;
                color: rgba(0, 183, 255, 0.8);
                margin-left: 10px;
              }
            }
          }

          &.isMy {
            text-align: right;
            padding-left: 0;

            .msg-inner {
              padding: 0;
              padding-right: 60px;
            }

            .pic {
              position: absolute;
              left: auto;
              right: 0;
            }

            .msg {
              text-align: left;
              display: inline-block;
            }
          }
        }
      }

      .sendBox {
        height: 50px;
        display: flex;
        align-items: center;
        box-shadow: 2px 4px 12px -9px rgba(255, 255, 255, 0.6);
        border-radius: 8px;
        border: 1px solid rgba(76, 151, 192, 0.6);

        &.disabled {
          .el-input {
            cursor: not-allowed;
          }

          .sendBtnm,
          .microphone {
            pointer-events: none;
          }
        }

        /deep/ .el-input {
          margin: 0 10px;
          height: 100%;

          input {
            height: 100%;
            font-size: 15px;
            border: 0;
            background-color: transparent;
            padding: 0 5px;
            color: #fff;
          }
        }

        .btn-inner {
          padding: 0 12px;
          filter: brightness(100);
        }

        .btn-inner+.btn-inner {
          border-left: 1px solid rgba(76, 151, 192, 0.3);
        }

        .huatong {
          width: 30px;
          min-width: 30px;
          height: 30px;
        }

        .sendBtn {
          width: 30px;
          min-width: 30px;
          height: 30px;
          cursor: pointer;

          img {
            height: 100%;
            width: 100%;
            object-fit: contain;
          }
        }
      }
    }

    .szr-wrap {
      width: 370px;
      min-width: 370px;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      pointer-events: none;
      background-color: rgba(51, 106, 135, 0.5);
      border-radius: 10px;
      box-shadow: 0 0 20px -10px #666;
      overflow: hidden;
      position: relative;
      box-shadow: 0 0 20px -5px rgba(138, 220, 255, 0.6) inset;
      border: 1px solid rgba(76, 151, 192, 0.6);

      video {
        object-fit: contain;
        background-color: #fff;
      }
    }

    .scorePanel {
      backdrop-filter: blur(5px);
      background: #fff;
      width: 300px;
      min-width: 300px;
      border-radius: 10px;
      box-shadow: 0 0 20px -10px #666;
      padding: 20px;
      box-sizing: border-box;
      margin-left: 15px;
      border: 1px solid rgba(76, 151, 192, 0.6);
      box-shadow: 0 0 20px -5px rgba(138, 220, 255, 0.6) inset;
      background-color: rgba(51, 106, 135, 0.5);
      color: #3df2ff;

      .title-inner {
        height: 50px;
        line-height: 30px;
        display: flex;
        font-size: 17px;

        span {
          margin-left: auto;
          color: #fff;
        }
      }

      .content-inner {
        height: calc(100% - 220px);
        background: rgba(82, 145, 187, 0.3);
        border-radius: 10px;
        overflow: hidden;

        /deep/.el-table {
          &,
          tr,
          .el-table__cell {
            background-color: transparent;
            color: #000;
            border-color: rgba(255, 255, 255, 0.5);
            color: #fff;
            text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.3);
          }

          th {
            text-align: center;
          }

          &::before {
            display: none;
          }
        }
      }

      .footer-innerr {
        height: 160px;
        line-height: 1.2;
        margin-top: 10px;
        background: rgba(82, 145, 187, 0.3);
        padding: 20px;
        border-radius: 10px;
        box-sizing: border-box;
        overflow: auto;
        color: #fff;
      }
    }
  }

  .sample-view {
    height: 40px;
    display: flex;
    align-items: center;

    img {
      height: 30px;
      margin-left: auto;
      position: relative;
      left: -10px;
      filter: hue-rotate(213deg) brightness(700%);
    }

    span {
      color: #999;
    }

    button {
      background-color: #48caf9;
      width: 84px;
      height: 32px;
      border: 0;
      color: #fff;
      text-shadow: 0 0 2px #000;

      &:hover {
        filter: brightness(110%);
      }

      &.closeBtn {
        background-color: #b6b6b6;
      }
    }
  }

}

.dialogContainer {
  display: flex;
  flex-direction: column;
  align-content: center;

  .container-t {
    .container-title {
      font-size: 16px;
      margin: 10px 0;
    }

    .container-desc {
      line-height: 1.5;
      text-indent: 2em;
    }
  }

  .container-b {
    .container-title {
      font-size: 16px;
      margin: 10px 0;
    }

    .smpic {
      width: 9.55rem;
      height: 2.95rem;

      img {
        width: 100%;
        height: 100%;
        display: block;
      }
    }
  }
}
</style>
<style lang="less" scoped>
/**
 * -------------------------------------------------------
 * 滚动条
 * -------------------------------------------------------
 */
::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 5px;
  height: 5px;
}

::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 5px;
  box-shadow: inset 0 0 10px -2px #ffffff;
}

::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  /*background: #ddd;*/
}
</style>